import type { GrowthBook } from '@growthbook/growthbook';

export let growthBook: GrowthBook | null = null;

export const setGrowthBook = (gb: GrowthBook) => (growthBook = gb);
